/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerCreateBatchMutationRequest, TransferBatchesControllerCreateBatchMutationResponse, TransferBatchesControllerCreateBatch400, TransferBatchesControllerCreateBatch401, TransferBatchesControllerCreateBatch403, TransferBatchesControllerCreateBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerCreateBatch";

function getTransferBatchesControllerCreateBatchUrl() {
  const res = { method: 'POST', url: `/api/v1/transfer-batches` as const }  
  return res
}

/**
 * @summary Create a new transfer batch
 * {@link /api/v1/transfer-batches}
 */
export async function transferBatchesControllerCreateBatch(data?: TransferBatchesControllerCreateBatchMutationRequest, config: Partial<RequestConfig<TransferBatchesControllerCreateBatchMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferBatchesControllerCreateBatchMutationResponse, ResponseErrorConfig<TransferBatchesControllerCreateBatch400 | TransferBatchesControllerCreateBatch401 | TransferBatchesControllerCreateBatch403 | TransferBatchesControllerCreateBatch404>, TransferBatchesControllerCreateBatchMutationRequest>({ method : "POST", url : getTransferBatchesControllerCreateBatchUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}